import { fork, all } from 'redux-saga/effects'
import faqSaga from '../containers/FAQs/sagas'
import videosSaga from '../containers/Videos/sagas'
import guidesSaga from '../containers/Guides/sagas'
import specsSaga from '../containers/Specs/sagas'
import tutorialsSaga from '../containers/Tutorials/sagas'
import relatedSaga from '../containers/RelatedSidebar/sagas'
import devicesSaga from '../containers/DeviceSelector/sagas'
import gettingStartedSaga from '../containers/GettingStarted/sagas'
import appSaga from '../containers/App/sagas'
import userEventSata from '../containers/UserEvents/sagas'
import contactOptionsSaga from '../containers/ContactUsModal/sagas'
import searchSaga from '../containers/ESSearch/sagas'
import footerSaga from '../containers/Footer/sagas'
import headerSaga from '../containers/Header/sagas'

export default function* rootSaga() {
  yield all([
    fork(faqSaga),
    fork(videosSaga),
    fork(guidesSaga),
    fork(specsSaga),
    fork(tutorialsSaga),
    fork(relatedSaga),
    fork(devicesSaga),
    fork(gettingStartedSaga),
    fork(userEventSata),
    fork(contactOptionsSaga),
    fork(searchSaga),
    fork(appSaga),
    fork(footerSaga),
    fork(headerSaga)
  ])
}



// WEBPACK FOOTER //
// ./src/store/sagas.js